import React from 'react';
import { CommandBarButton, IconButton } from '@fluentui/react';
import DetailsTable from '../../../Table/DetailsTable';

const CustomDashboardTasksTable = ({
    tasks,
    setSelectedTask,
    loading,
    editOnClick,
    createOnClick,
    deleteOnClick,
}) => {
    const columns = [
        {
            minWidth: 30,
            maxWidth: 30,
            onRender: (item) => (
                <ContextualMenu 
                    editOnClick={editOnClick} 
                    id={item.customTaskId} 
                    item={item} 
                    deleteOnClick={deleteOnClick} 
                />
            ),
        },
        {
            name: 'Slug',
            fieldName: 'slug',
            minWidth: 200,
            maxWidth: 250,
            isResizable: true,
        },
        {
            name: 'Title',
            fieldName: 'title',
            minWidth: 200,
            maxWidth: 300,
            isResizable: true,
        },
        {
            name: 'Category',
            fieldName: 'category',
            minWidth: 100,
            maxWidth: 150,
            isResizable: true,
        },
        {
            name: 'Cobrand',
            fieldName: 'cobrandName',
            minWidth: 150,
            maxWidth: 200,
            isResizable: true,
            onRender: (item) => item.cobrandName || item.cobrandTagName || 'N/A',
        },
        {
            name: 'Units',
            fieldName: 'unitIds',
            minWidth: 90,
            maxWidth: 120,
            isResizable: true,
            onRender: (item) => item.unitIds?.length ? `${item.unitIds.length} selected` : 'All',
        },
        {
            name: 'Points',
            fieldName: 'points',
            minWidth: 60,
            maxWidth: 80,
            isResizable: true,
        },
        {
            name: 'Active',
            fieldName: 'isActive',
            minWidth: 60,
            maxWidth: 80,
            isResizable: true,
            onRender: (item) => item.isActive ? 'Yes' : 'No',
        },
    ];

    const items = tasks ?? [];

    const selectionHook = (items) => {
        const selectedItem = items && items[0];
        setSelectedTask(selectedItem);
    };

    return (
        <DetailsTable
            items={items}
            columns={columns}
            selectionHook={selectionHook}
            loading={loading}
            mainColumn={'slug'}
            style={{
                position: 'relative',
                height: '80vh',
                width: '90vw',
            }}
            CommandBar={
                <CommandBarButton
                    iconProps={{ iconName: 'Add' }}
                    text="Add Custom Task"
                    onClick={() => createOnClick()}
                />
            }
        />
    );
};

const moreIcon = { iconName: 'More' };

const ContextualMenu = ({ editOnClick, deleteOnClick, id, item, ...rest }) => {
    const menuProps = {
        items: [
            {
                key: 'edit',
                iconProps: { iconName: 'Edit' },
                text: 'Edit',
                onClick: () => editOnClick(id),
            },
            {
                key: 'delete',
                iconProps: { iconName: 'Delete' },
                text: 'Delete',
                onClick: () => deleteOnClick(id, item?.slug || ''),
            },
        ],
    };

    return <IconButton iconProps={moreIcon} menuProps={menuProps} onRenderMenuIcon={() => {}} {...rest} />;
};

export default CustomDashboardTasksTable;
